var sliderData = {
  name: 'slider',
  data: [{
    railBg: '#e2e2e2',
    trackBg: '#5365EA',
    marginLeft: '-.05rem',
    marginTop: '-.05rem',
    background: 'white',
    handleBorder: '2px solid #5365EA',
    verticalTrackHeight: '100%',
    verticalDraghandleMarginLeft: '0rem',
    verticalIndicatorLeft: '15px',
    verticalIndicatorTop: '-35%',
    focusedShadow: 'rgb(171 202 255) 0px 0px 0px 0.05rem'
  }]
};
export default sliderData;